import { render, staticRenderFns } from "./ppSankey.vue?vue&type=template&id=daf0efe2&"
import script from "./ppSankey.vue?vue&type=script&lang=js&"
export * from "./ppSankey.vue?vue&type=script&lang=js&"
import style0 from "./ppSankey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports